import { RecommendationDetail } from '@/components/recommendations/RecommendationDetail';

export default function RecommendationDetailPage() {
  return <RecommendationDetail />;
}